import React from 'react';
import cloneArray from './cloneArray';
import { isAnObject } from './isAnObject';

interface Obj {
    [key: string]: any
}

export default function cloneObject<T extends Obj>(object: T): T {
    let clonedObject = {} as Obj;
    Object.keys(object).forEach(key => {
        const currentValue = object[key];
        if (React.isValidElement(currentValue))
            clonedObject[key] = currentValue;
        else if (isAnObject(currentValue))
            clonedObject[key] = cloneObject(currentValue);
        else if (Array.isArray(currentValue))
            clonedObject[key] = cloneArray(currentValue);
        else
            clonedObject[key] = currentValue;
    });
    return clonedObject as T;
}
